import React from 'react';
import './Grid-View.css';
import ScrollAnimation from 'react-animate-on-scroll';
import "animate.css/animate.min.css";

const Zdjecie = ( props ) => {
    var zdjecie = {
        width: '100%',
        height: "100%"
    };
    var linia = {
    };
    var fade = "fadeInUp";
    if (props.strona === "lewa") {
        linia.left= '0'
        linia.top= '0'
    } else if (props.strona === "prawa") {
        linia.left= '50%'
        linia.top= '0'
    };
    if (window.innerHeight > window.innerWidth)
    {
        linia.position= "relative"
        linia.width= '100%'
        linia.left= '0%'
        linia.top= '0'
        linia.height= 'auto'
        fade = ' '
    };
    if (!props.animatnion) {
        fade = ' '
    };
    return (
        <ScrollAnimation animateIn={fade} animateOnce="true" className="inline" style={linia}>
                <img style={zdjecie} src={props.zdj} className="grid-img" />
                <div className="sign">{props.sign}</div>
        </ScrollAnimation>
    );
}

export default Zdjecie;


// WEBPACK FOOTER //
// ./src/Grid-View/Zdjecie.js